import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api/v1`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function apiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return error?.message || "Unexpected error";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export function wsUrl(projectId) {
  const url = new URL(`${BASE}/api/v1/ws/projects/${projectId}`);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  return url.toString();
}

export function adminWsUrl() {
  const url = new URL(`${BASE}/api/v1/ws/admin`);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  return url.toString();
}

export function downloadUrl(path) {
  return `${API}${path}`;
}
